import { render, staticRenderFns } from "./PageNavigation.vue?vue&type=template&id=281e10b6&scoped=true&"
var script = {}
import style0 from "./PageNavigation.vue?vue&type=style&index=0&id=281e10b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e10b6",
  null
  
)

export default component.exports